import { type DashRouteType, URL_RETAILER_SCOPED } from '@retailer-platform/dashboard/routing'

const URL_INSIGHTS_PORTAL_LIB = `${URL_RETAILER_SCOPED}/insights-portal-lib`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'insights-portal-lib'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'insights-portal-lib': URL_INSIGHTS_PORTAL_LIB,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
